export default __webpack_public_path__ + "static/media/pie.c447e690.png";